import React, { Component } from 'react';

import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade } from 'react-bootstrap';

import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';
import './Blurb.css'

import { AutoAffix } from 'react-overlays';

export default class StarsBlurb extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>Through the Stars</h3>
                <p className='blurb-text'>Through the Stars is a 2D platformer with a twist! Venture through space, jumping between tiny planets. Avoid the aliens and make it back to your rocketship!</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/StarsBlurb.jsx